import { FC, ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { ClaimsListAllowedKeys, useUserClaim } from "@/utils/useUserClaims";
import { DashboardRoutes } from "./constant";

interface Props {
  claims: ClaimsListAllowedKeys[];
  children: ReactNode;
}

/**
 * Component to conditionally render its children based on user permissions.
 *
 * @param {ClaimsListAllowedKeys[]} props.claims - An array of permission claims required for rendering.
 * @param {ReactNode} props.children - The child elements to render if the user has the required permissions.
 * @returns {JSX.Element} The component's JSX representation.
 */

export const RequireRole: FC<Props> = ({ claims, children }) => {
  const { hasPermission } = useUserClaim(claims);

  return hasPermission ? children : <Navigate to={DashboardRoutes.home.root.url} replace />;
};
